// Índice de documentos de la categoría: Flujos
import crear_flujo_botones from './crear-flujo-botones.js';
import integrar_ia_flujos from './integrar-ia-flujos.js';
import controlar_flujos from './controlar-flujos.js';
import formato_fecha_hora from './formato-fecha-hora.js';

const flujosDocs = [
  crear_flujo_botones,
  integrar_ia_flujos,
  controlar_flujos,
  formato_fecha_hora,
];

export default flujosDocs;
